import { useEffect, useState } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { BUSINESS } from "@/data/salonData";

const NAV = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Membership", href: "#membership" },
  { label: "Pre-Bridal", href: "#prebridal" },
  { label: "Academy", href: "#academy" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "py-2" : "py-4"
      }`}
    >
      <div
        className={`mx-3 md:mx-6 rounded-2xl px-4 md:px-8 transition-all duration-500 ${
          scrolled ? "glass" : "bg-transparent"
        }`}
      >
        <div className="flex items-center justify-between h-14 md:h-16">
          {/* Logo */}
          <a
            href="#home"
            data-testid="logo-link"
            className="flex items-center gap-2.5 group"
          >
            <div className="relative w-10 h-10 rounded-full bg-gradient-to-br from-[#f9d0da] to-[#d98a99] flex items-center justify-center shadow-md">
              <Sparkles size={18} color="#fff" strokeWidth={2} />
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#d4af37]/0 to-[#d4af37]/30" />
            </div>
            <div className="leading-tight">
              <div className="font-display text-lg md:text-xl font-semibold text-[#2a1b18]">
                {BUSINESS.name}
              </div>
              <div className="text-[10px] tracking-[0.25em] text-[#b56477] uppercase hidden sm:block">
                {BUSINESS.tagline}
              </div>
            </div>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className="text-sm text-[#2a1b18]/80 hover:text-[#b56477] transition-colors font-medium"
              >
                {n.label}
              </a>
            ))}
          </nav>

          {/* CTA + mobile menu */}
          <div className="flex items-center gap-2">
            <a
              href="#book"
              data-testid="header-book-btn"
              className="hidden sm:inline-flex btn-rose px-5 py-2.5 rounded-full text-sm font-medium"
            >
              Book Appointment
            </a>
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen((o) => !o)}
              className="lg:hidden w-10 h-10 rounded-full glass flex items-center justify-center text-[#b56477]"
              aria-label="Menu"
            >
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>

        {/* Mobile dropdown */}
        {open && (
          <div
            data-testid="mobile-menu"
            className="lg:hidden pb-4 pt-2 grid grid-cols-2 gap-2"
          >
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="px-4 py-2.5 rounded-xl text-sm text-[#2a1b18] hover:bg-[#fff0f5] hover:text-[#b56477] transition-colors font-medium"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={() => setOpen(false)}
              className="col-span-2 btn-rose px-4 py-3 rounded-xl text-sm font-medium text-center"
            >
              Book Appointment
            </a>
          </div>
        )}
      </div>
    </header>
  );
}
